import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { DatePipe } from '@angular/common';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { Router } from '@angular/router';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { stringify } from 'querystring';
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

export enum enAllocationType {
  Allocation = 0,
  ReAllocation = 1,
  View = 2
};

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css']
})
export class ManualComponent implements OnInit {

  //docTypeList: { docTypeId: number, docTypeName: string }[] = [];
  dateFormat = new DatePipe('en-US');
  docTypeList: any = [];
  lstProcess = [];
  lstRole = [];
  lstAssociate = [];
  lstPriority = [];
  lstAssigned = [];
  lstReAssigned = [];
  lstReAssignedAll = [];
  lstProcessData = [];
  lstHeaders = [];
  lstHeaders_log = [];

  advanceSearchSummaryFields: any = [];
  advanceSearchFilterFields: any = [];
  advanceSearchSummaryStaticFields: any = {
    URN: "",
    Priority: "",
    SOURCE: "",
    FROM_EMAIL: "",
    Created_Dt_From: "",
    Created_Dt_To: ""
  };

  selectedDocumentType: { docTypeId: number, docTypeName: string } = { docTypeId: 0, docTypeName: '' };
  selectedProcess: any = {};
  selectedRole: any = {};
  selectedAssociate: any = {};
  selectedAssigned: any = {};
  selectedReAssigned: any = {};
  selectedPriority: any = {};
  selectedRecords: any = [];
  activeAllocationType: Number = 2;


  activeProcess: number = 0;
  processName: string = '';
  activeDocument: number = 0;
  selectedDocument: string = '';
  viewType: string = 'TABULAR';
  sortColumnInfo = { name: '', isOrderAsc: true };

  selectedCellIndex: number = -1;
  selectedRowIndex: number = -1;
  saveAsDefaultFilter: boolean = false;
  currentPage: any = 1;
  recordsperPage: any = 10;
  type: number = 0;
  countStickyGridWidth: number = 200;

  isOpenDoctypeModel: boolean = true;
  isDisplayDocModel = false;
  isShowAllocationList: boolean = false;
  allocationColumnsToHide: any = ['DOCUMENT_DETAIL_ID'];
  isDisabledAllocationButton: boolean = true;
  buttonText = "Allocate";
  strRange: string = '1-9999999';
  @ViewChild('documentTypeModal') documentTypeModal: ElementRef;
  @ViewChild('page_section') public pageSection: ElementRef;
  @ViewChild('summary_grid') public summaryGrid: ElementRef;
  @ViewChild('gridTransactionData') gridAllocationData: AdvanceGridviewComponent;
  @ViewChild('ddlAssignedTo') ddlAssignedTomultiselect: DropdownMultiselectComponent;
  modalReference: any;

  constructor(private commonService: CommonService, private dataService: DataService,
    private route: Router, private modalService: NgbModal, private encryptDecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) { }

  ngOnInit(): void {
    this.getDocumentType();
    this.activeAllocationType = 0;
    this.isShowAllocationList = false;
  }

  getDocumentType() {

    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('action', 'manual allocation');
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.docTypeList = [];
              for (var i = 0; i < res.data.length; i++) {
                this.docTypeList.push({
                  docTypeId: res.data[i].document_type_id,
                  docTypeName: res.data[i].document_type_name,
                });
              }
              this.showModal(this.documentTypeModal, 'sm');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  onChangeDoctype(doc) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = doc;
    //this.getProcessDataForView();    
    //this.getAssociate();
    this.onSelected(this.activeAllocationType);
    this.getPriority();
    this.modalReference.close();
    this.isShowAllocationList = false;
    this.isDisabledAllocationButton = true;
  }

  async onSelected(selected) {

    this.activeAllocationType = selected;
    this.selectedProcess = { id: 0, name: '' };
    this.selectedRole = { id: 0, name: '' };
    this.selectedAssociate = { id: 0, name: '' };
    this.selectedAssigned = { id: 0, name: '' };
    this.selectedReAssigned = { id: 0, name: '' };
    this.selectedPriority = { id: 0, name: '' };
    this.advanceSearchSummaryStaticFields = { URN: "", Priority: "", SOURCE: "", FROM_EMAIL: "", Created_Dt_From: "", Created_Dt_To: "" };
    this.isDisabledAllocationButton = true;
    if (selected == enAllocationType.Allocation) {
      this.type = 0;
      this.getProcess();
      this.buttonText = "Allocate";
      this.isShowAllocationList = false;
    }
    else if (selected == enAllocationType.ReAllocation) {
      this.type = 1;
      this.getProcess();
      this.buttonText = "Reallocate";
      this.isShowAllocationList = false;
    }
    else {
      this.type = 2
      await this.getAdvanceSearchFields(true);
      this.getProcessDataForView();

    }
  }

  async getProcessDataForView() {
    if (this.lstProcessData.length > 0) {
      this.lstProcessData.splice(0, this.lstProcessData.length)
    }
    this.lstHeaders = [];
    this.selectedRecords = [];
    let searchColumns = {};
    let indexRange: any;

    if (this.selectedProcess.id <= 0 && (this.activeAllocationType == enAllocationType.Allocation || this.activeAllocationType == enAllocationType.ReAllocation)) {
      this.commonService.showMessageBox("Please select process", 'Alert');
      return;
    }

    if (this.selectedRole.id <= 0 && (this.activeAllocationType == enAllocationType.Allocation || this.activeAllocationType == enAllocationType.ReAllocation)) {
      this.commonService.showMessageBox("Please select role", 'Alert');
      return;
    }

    if (this.activeAllocationType == enAllocationType.Allocation || this.activeAllocationType == enAllocationType.ReAllocation) {
      indexRange = this.strRange.split('-');
      if (indexRange.length != 2) {
        this.commonService.showMessageBox("Please enter valid range like (1-9999999)", 'Alert');
        return;
      }

      if (isNaN(indexRange[0]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range", 'Alert');
        return;
      }

      if (isNaN(indexRange[1]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }
      if (indexRange[0] == 0 || indexRange[1] == 0) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }

      if (indexRange[0] > indexRange[1]) {
        this.commonService.showMessageBox("Please enter valid range.", 'Alert');
        return;
      }
    }
    else {
      let range: string = "0-0";
      indexRange = range.split('-');

    }
    this.advanceSearchSummaryFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });

    if (this.selectedAssigned.length <= 0 && this.activeAllocationType == enAllocationType.ReAllocation) {
      this.commonService.showMessageBox("Please select atleast one current assigned to.", 'Alert');
      return;
    }

    // this.commonService.setUserInfoToLocalStorage('allocationGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
    this.memorystore.setItem('allocationGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: (this.activeAllocationType == enAllocationType.View ? this.commonService.selectedRole : this.selectedRole.id),
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: (this.activeAllocationType == enAllocationType.ReAllocation ? this.selectedAssigned.toString() : this.commonService.getUserInfoFromLocalStorage('userId')),
      // user_id: (this.activeAllocationType == enAllocationType.ReAllocation ? this.selectedAssigned.toString() : this.memorystore.getItem('userId')),
      user_id: (this.activeAllocationType == enAllocationType.ReAllocation ? this.selectedAssigned.toString() : this.memorystore.getItem('userId')),
      allocation_type: this.activeAllocationType,
      document_type_ids: this.selectedDocumentType.docTypeId.toString(),
      process_ids: this.selectedProcess.id.toString(),
      search_columns: searchColumns,
      from_range: Number(indexRange[0]),
      to_range: Number(indexRange[1]),
      urn: '',
      priority: [],
      source: "",
      from_email: "",
      date_range: null
    };

    let parentSearchField = this.advanceSearchSummaryStaticFields;
    if (this.commonService.readObject(parentSearchField) != null) {
      if (parentSearchField.Priority != "") {
        reqData.priority.push(parentSearchField.Priority)
      }
      reqData.urn = parentSearchField.URN;
      reqData.source = parentSearchField.SOURCE;
      reqData.from_email = parentSearchField.FROM_EMAIL;
      if (this.commonService.readInput(parentSearchField.Created_Dt_From) != "" && this.commonService.readInput(parentSearchField.Created_Dt_To) != "")
        reqData.date_range = { "start_date": parentSearchField.Created_Dt_From, "end_date": parentSearchField.Created_Dt_To };
    }


    this.dataService.postData('allocation-details', reqData).subscribe((res) => {
      if (res != null && res != undefined && res.data != null && res.data.length > 0) {
        this.lstHeaders = res.data[0].table_sections;
        this.lstHeaders_log.forEach(sec => {
          sec.section_fields.forEach(f => {
            let field = this.lstHeaders.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
            if (field) {
              field.is_visible = f.is_visible;
            }
          });
        });

        this.lstProcessData = res.data[0].table_data;

        if (this.lstProcessData.length <= 0) {
          this.commonService.showMessageBox('No data found', 'Message');
        }
        this.isShowAllocationList = true;
      }
      else {
        this.isShowAllocationList = false;
        this.commonService.showMessageBox('No data found', 'Message');
      }
    });
  }

  getProcess() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('allocated', this.activeAllocationType == enAllocationType.ReAllocation);
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('allocation-process-type', params).subscribe((res) => {
      if (res != null && res.data != null) {
        this.lstProcess = [];
        res.data.forEach((element) => {
          this.lstProcess.push({
            id: element.process_id,
            name: element.process_name + ' (' + element.doc_count + ')'
          });
        });
      }
      else {
        if (this.activeAllocationType == enAllocationType.Allocation) {
          this.commonService.showMessageBox('No documents available for allocation', 'Alert');
        }
        else if (this.activeAllocationType == enAllocationType.ReAllocation) {
          this.commonService.showMessageBox('No documents available for re-allocation', 'Alert');
        }
      }
    });
  }

  getRole() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('process_id', this.selectedProcess.id.toString());
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('pwm_id', 0);
    this.dataService.getData('allocation-roles', params).subscribe((res) => {
      if (res != null && res.data != null) {
        this.lstRole = [];
        res.data.forEach((element) => {
          this.lstRole.push({
            id: element.id,
            name: element.name,
          });
        });
      }
    });
  }

  getPriority() {
    this.lstPriority = [];
    this.lstPriority.push({ id: 1, name: 'High' });
    this.lstPriority.push({ id: 2, name: 'Normal' });
    //this.lstPriority.push({ id: 3, name: 'Medium' });
    //'Medium', arun decided to remove from the priority
    //discussed and confirmed on 13-06-2022.
  }

  getAssociate() {
    this.lstAssociate = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.selectedRole.id);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('process_id', 0);
    params = params.append('allocated', false);
    this.dataService.getData('allocation-users', params).subscribe((res) => {
      if (res != null && res.data != null) {
        res.data.forEach((element) => {
          this.lstAssociate.push({
            id: element.user_id,
            name: element.user_name + '(' + element.doc_count + ')'
          });
        });
      }
      else {
        this.commonService.showMessageBox('No users available for selected role', 'Alert');
      }
    });
  }
  getAssigned() {
    this.lstAssigned = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.selectedRole.id);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('process_id', this.selectedProcess.id.toString());
    params = params.append('allocated', true);
    this.dataService.getDataPromise('reallocation-users', params).then((res) => {
      if (res != null && res.data != null && res.data.length > 0) {
        res.data.forEach((element) => {
          this.lstAssigned.push({
            value: element.user_id,
            text: element.user_name + '(' + element.doc_count + ')',
            selected: true,
          });

        });

        this.selectedAssigned = [];
        this.lstAssigned.forEach((element) => {
          if (element.selected == true) {
            this.selectedAssigned.push(element.value);
          }
        });

        this.ddlAssignedTomultiselect.allSelected = true;
        this.ddlAssignedTomultiselect.ngAfterViewInit();


      }
      else {
        this.commonService.showMessageBox('No users available for selected role', 'Alert');
      }
    });
  }

  getReAssigned() {
    this.lstReAssigned = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.selectedRole.id);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('allocated', false);
    this.dataService.getData('allocation-users', params).subscribe((res) => {
      if (res != null && res.data != null) {
        res.data.forEach((element) => {
          this.lstReAssigned.push({
            id: element.user_id,
            name: element.user_name + '(' + element.doc_count + ')'
          });
        });
      }
      else {
        this.commonService.showMessageBox('No users available for selected role', 'Alert');
      }
    });
  }

  onSelectProcess(process) {
    this.selectedProcess = process;
    this.getRole();
    // this.enableSubmitButton();
  }

  async onSelectRole(role) {
    this.selectedRole = role;

    // this.enableSubmitButton();
    if (this.activeAllocationType == enAllocationType.Allocation) {
      this.getAssociate();
      // await this.getAdvanceSearchFields(true);
      // this.getProcessDataForView();
    }

    if (this.activeAllocationType == enAllocationType.ReAllocation) {

      this.getAssigned();
      this.getReAssigned();
      //this.onSelectAssigned();
    }
  }

  onSelectAssociate(associate) {
    this.selectedAssociate = associate;
    this.enableSubmitButton();
  }

  async onSelectAssigned() {

    // if (this.selectedAssigned.id == 0) {
    // this.selectedAssigned = [];
    // this.lstAssigned.forEach((element) => {
    //   if (element.selected == true) {
    //     this.selectedAssigned.push(element.value);
    //   }
    // });
    //}

    this.enableSubmitButton();
    if (this.activeAllocationType == enAllocationType.ReAllocation) {
      await this.getAdvanceSearchFields(true);
      this.getProcessDataForView();
    }

  }


  onAssignedToChange(event: any) {

    this.selectedAssigned = event.selectedValues;

    //this.enableSubmitButton();
    // if (this.activeAllocationType == enAllocationType.ReAllocation) {
    //   await this.getAdvanceSearchFields(true);
    //   this.getProcessDataForView();
    // }

  }

  onSelectReAssigned(reassign) {
    this.selectedReAssigned = reassign;
    this.enableSubmitButton();
  }

  onSelectPriority(priority) {
    this.selectedPriority = priority;
    this.enableSubmitButton();
  }

  cellClickEvent(event: any) {

    if (event.columnName.toLowerCase() == 'urn') {

      let data = {
        documentDetailId: event.rowData['DOCUMENT_DETAIL_ID'],
        isReadonlyMode: true
      }
      EmmiterService.get("transactionLiteModal").emit(data);

    }
  }
  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }
  enableSubmitButton() {
    let isSubmitValid: boolean = true;
    if (this.activeAllocationType == enAllocationType.Allocation) {

      if (this.selectedDocumentType.docTypeName == '' || this.selectedDocumentType.docTypeName == undefined || this.selectedDocumentType.docTypeName == null) {
        isSubmitValid = false;
      }

      if (this.selectedProcess.name == '' || this.selectedProcess.name == undefined || this.selectedProcess.name == null) {
        isSubmitValid = false;
      }

      if (this.selectedRole.name == '' || this.selectedRole.name == undefined || this.selectedRole.name == null) {
        isSubmitValid = false;
      }

      if (this.selectedAssociate.name == '' || this.selectedAssociate.name == undefined || this.selectedAssociate.name == null) {
        isSubmitValid = false;
      }
      // if (this.selectedPriority.name == '' || this.selectedPriority.name == undefined || this.selectedPriority.name == null) {
      //   isSubmitValid = false;
      // }
      this.isDisabledAllocationButton = !isSubmitValid;

    }
    else if (this.activeAllocationType == enAllocationType.ReAllocation) {

      if (this.selectedDocumentType.docTypeName == '' || this.selectedDocumentType.docTypeName == undefined || this.selectedDocumentType.docTypeName == null) {
        isSubmitValid = false;
      }

      if (this.selectedProcess.name == '' || this.selectedProcess.name == undefined || this.selectedProcess.name == null) {
        isSubmitValid = false;
      }

      if (this.selectedRole.name == '' || this.selectedRole.name == undefined || this.selectedRole.name == null) {
        isSubmitValid = false;
      }

      if (this.selectedAssigned.length <= 0) {
        isSubmitValid = false;
      }

      if (this.selectedReAssigned.name == '' || this.selectedReAssigned.name == undefined || this.selectedReAssigned.name == null) {
        isSubmitValid = false;
      }
      // if (this.selectedPriority.name == '' || this.selectedPriority.name == undefined || this.selectedPriority.name == null) {
      //   isSubmitValid = false;
      // }
      this.isDisabledAllocationButton = !isSubmitValid;
    }
    else {
      this.isDisabledAllocationButton = isSubmitValid;
    }
  }
  onSubmitButtonClick() {

    if (this.activeAllocationType == enAllocationType.Allocation) {

      let isSubmitValid = true;
      let invalidSubmitMsg = '';

      if (this.selectedDocumentType.docTypeName == '' || this.selectedDocumentType.docTypeName == undefined || this.selectedDocumentType.docTypeName == null) {
        invalidSubmitMsg += 'Please select document type\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedProcess.name == '' || this.selectedProcess.name == undefined || this.selectedProcess.name == null) {
        invalidSubmitMsg += 'Please select proccess\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedRole.name == '' || this.selectedRole.name == undefined || this.selectedRole.name == null) {
        invalidSubmitMsg += 'Please select role\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedAssociate.name == '' || this.selectedAssociate.name == undefined || this.selectedAssociate.name == null) {
        invalidSubmitMsg += 'Please select user\r <br/>';
        isSubmitValid = false;
      }
      // if (this.selectedPriority.name == '' || this.selectedPriority.name == undefined || this.selectedPriority.name == null) {
      //   invalidSubmitMsg += 'Please select priority\r <br/>';
      //   isSubmitValid = false;
      // }

      this.lstProcessData ?.forEach((element) => {
        if (element.action_checkbox_button == true) {
          this.selectedRecords.push(element.DOCUMENT_DETAIL_ID)
        }
      })

      if (this.selectedRecords.length <= 0) {
        invalidSubmitMsg += 'Please select transaction records\r <br/>';
        isSubmitValid = false;
      }


      if (!isSubmitValid) {
        this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
        return;
      }

      let params = {
        project_Id: this.commonService.selectedProject,
        subgroup_Id: this.commonService.selectedSubgroup,
        //Role_Id: this.selectedRole.id,
        user_Id: this.selectedAssociate.id,
        allocation_Type: this.activeAllocationType,
        priority: this.selectedPriority.name,
        // created_By: this.commonService.getUserInfoFromLocalStorage('userId'),
        created_By:this.memorystore.getItem('userId'),
        document_Detail_Ids: this.selectedRecords.toString(),

      };
      this.dataService.postData('manual-allocation', params).subscribe(async (res) => {
        if (res != null && res != undefined && res.data != null) {
          this.commonService.showMessageBox(res.data, 'Message');
          // this.selectedProcess = { id: 0, name: '' };
          // this.selectedRole = { id: 0, name: '' };
          // this.selectedAssociate = { id: 0, name: '' };
          // this.selectedAssigned = [];
          // this.selectedReAssigned = { id: 0, name: '' };
          // this.selectedPriority = { id: 0, name: '' };
          this.ClearOpenSearch();
          // this.getProcess();
          this.isShowAllocationList = false;


        }
        else {

        }
      });
    }
    else if (this.activeAllocationType == enAllocationType.ReAllocation) {
      let isSubmitValid = true;
      let invalidSubmitMsg = '';

      if (this.selectedDocumentType.docTypeName == '' || this.selectedDocumentType.docTypeName == undefined || this.selectedDocumentType.docTypeName == null) {
        invalidSubmitMsg += 'Please select document type\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedProcess.name == '' || this.selectedProcess.name == undefined || this.selectedProcess.name == null) {
        invalidSubmitMsg += 'Please select proccess\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedRole.name == '' || this.selectedRole.name == undefined || this.selectedRole.name == null) {
        invalidSubmitMsg += 'Please select role\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedAssigned.length <= 0) {
        invalidSubmitMsg += 'Please select assigned user\r <br/>';
        isSubmitValid = false;
      }

      if (this.selectedReAssigned.name == '' || this.selectedReAssigned.name == undefined || this.selectedReAssigned.name == null) {
        invalidSubmitMsg += 'Please select re-assigned user\r <br/>';
        isSubmitValid = false;
      }
      // if (this.selectedPriority.name == '' || this.selectedPriority.name == undefined || this.selectedPriority.name == null) {
      //   invalidSubmitMsg += 'Please select priority\r <br/>';
      //   isSubmitValid = false;
      // }
      this.lstProcessData ?.forEach((element) => {
        if (element.action_checkbox_button == true) {
          this.selectedRecords.push(element.DOCUMENT_DETAIL_ID)
        }
      })

      if (this.selectedRecords.length <= 0) {
        invalidSubmitMsg += 'Please select transaction records\r <br/>';
        isSubmitValid = false;
      }

      if (!isSubmitValid) {
        this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
        return;
      }
      let params = {
        Project_Id: this.commonService.selectedProject,
        Subgroup_Id: this.commonService.selectedSubgroup,
        Role_Id: this.selectedRole.id,
        User_Id: this.selectedReAssigned.id,
        // Assigned_User_Id: this.selectedAssigned.toString(),
        Allocation_Type: this.activeAllocationType,
        Priority: this.selectedPriority.name,
        Created_Dt: this.dateFormat.transform(new Date(), 'yyyy/MM/dd').toString(),
        // Created_By: this.commonService.getUserInfoFromLocalStorage('userId'),
        Created_By: this.memorystore.getItem('userId'),
        Document_Detail_Ids: this.selectedRecords.toString(),
      };
      this.dataService.postData('manual-allocation', params).subscribe(async (res) => {
        if (res != null && res != undefined && res.data != null) {
          this.commonService.showMessageBox(res.data, 'Message');
          // this.selectedProcess = { id: 0, name: '' };
          // this.selectedRole = { id: 0, name: '' };
          // this.selectedAssociate = { id: 0, name: '' };
          // this.selectedAssigned = [];
          // this.selectedReAssigned = { id: 0, name: '' };
          // this.selectedPriority = { id: 0, name: '' };
          // this.getProcess();
          this.ClearOpenSearch();
          this.isShowAllocationList = false;
        }
        else {

        }
      });
    }
    else {

    }
  }

  async getAdvanceSearchFields(isSummarySearch: boolean) {

    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: this.selectedDocumentType.docTypeId.toString(),
    };

    await this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
      if (res != null && res.data != null) {
        if (isSummarySearch) {
          this.advanceSearchSummaryFields = res.data;
          this.advanceSearchSummaryFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }

            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
          if (this.advanceSearchFilterFields.length > 0) {
            this.advanceSearchFilterFields.forEach((element) => {
              if (this.advanceSearchSummaryFields.findIndex((x) => x.db_column_name == element.db_column_name) > -1) {
                this.advanceSearchSummaryFields.find((x) => x.db_column_name == element.db_column_name).search_value = element.search_value;
              }
            });
          }
        } else {
          this.advanceSearchFilterFields = res.data;
          this.advanceSearchFilterFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }
            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
        }
      }
    });
  }
  advanceSearchClickEvent(parentSearchField: any) {
    this.advanceSearchSummaryStaticFields = parentSearchField;
    this.getProcessDataForView();
  }


  columnsFilterChangeEvent(lstHeaders: any) {
    this.lstHeaders_log = lstHeaders;
  }

  setPaginationLocalStorageEvent() {
    // this.commonService.setUserInfoToLocalStorage("manualallocation_CurrentPage", this.gridAllocationData.currentPage);
    // this.commonService.setUserInfoToLocalStorage("manualallocationSummary_RecordsPerPage", this.gridAllocationData.recordsPerPage);
    this.memorystore.setItem("manualallocation_CurrentPage", this.gridAllocationData.currentPage);
    this.memorystore.setItem("manualallocationSummary_RecordsPerPage", this.gridAllocationData.recordsPerPage);
  }

  async getOpenSearchData() {
    this.enableSubmitButton();
    if (this.activeAllocationType == enAllocationType.Allocation) {
      this.getAssociate();
      await this.getAdvanceSearchFields(true);
      this.getProcessDataForView();
    }
    else if (this.activeAllocationType == enAllocationType.ReAllocation) {
      // await this.getAssigned();
      this.getReAssigned();
      this.onSelectAssigned();

    }

  }
  ClearOpenSearch() {
    this.strRange = '1-9999999';

    this.lstRole = [];
    this.lstAssociate = [];
    this.lstProcessData = [];
    this.lstReAssigned = [];
    this.lstAssigned = [];
    this.isDisabledAllocationButton = true;
    this.selectedAssigned = [];
    this.getProcess();
    this.ddlAssignedTomultiselect.allSelected = true;
    this.ddlAssignedTomultiselect.ngAfterViewInit();
  }

}
